import React from "react";
import EventFeedbackResultsPanel from "../../../../components/EventFeedbackResultsPanel/EventFeedbackResultsPanel";

interface Props {
  eventId: string;
  eventName: string;
  eventOrganizerEmail: string;
}

const EventFeedbackTab: React.FC<Props> = ({ eventId, eventName, eventOrganizerEmail }) => {
  return (
      <EventFeedbackResultsPanel
        eventId={eventId}
        eventName={eventName}
        eventOrganizerEmail={eventOrganizerEmail}
      />
  );
};

export default EventFeedbackTab;
